import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface SidebarFooterProps {
  collapsed?: boolean
  creditChipSlot?: ReactNode
  themeToggleSlot?: ReactNode
  accountSlot?: ReactNode
  className?: string
}

export function SidebarFooter({
  collapsed = false,
  creditChipSlot,
  themeToggleSlot,
  accountSlot,
  className,
}: SidebarFooterProps) {
  return (
    <div className={cn("shrink-0", className)}>
      {!collapsed && creditChipSlot && (
        <div className="border-t border-border">{creditChipSlot}</div>
      )}
      {collapsed ? (
        <div className="border-t border-border py-2 flex flex-col items-center gap-1">
          {accountSlot}
          {themeToggleSlot}
        </div>
      ) : (
        <div className="border-t border-border px-3 py-2 flex items-center gap-1">
          {accountSlot}
          <div className="ml-auto flex items-center gap-0.5">{themeToggleSlot}</div>
        </div>
      )}
    </div>
  )
}
